import StatusChip from '@bit/vibedev.web.components.status-chip';

export default StatusChip;
